import { CustomerRow } from './CustomersV2.types';
import { daysUntilExpiry } from './expiryDays';

/**
 * Whether the buyer can spend against the limit on the row right now: the offer
 * has to stand and its timeout must not have passed. A `null` timeout is a limit
 * the API doesn't lapse.
 *
 * Shared by the customers table and the profile modal, which a seller opens from
 * the row itself — a limit the table paints as spendable must not open onto
 * "Subject to approval".
 */
export const isSpendableLimit = (row: CustomerRow): boolean => {
  if (row.spending_limit_status.value !== 'offer_approved') return false;
  return row.limit_timeout === null || daysUntilExpiry(row.limit_timeout) > 0;
};
